import { Text } from "@mantine/core";

interface TooltipContentProps {
  description: string;
  details: string[];
}

const TooltipContent = ({ description, details }: TooltipContentProps) => {
  return (
    <>
      <Text size="sm" fw={500} className="text-gray-800">
        {description}
      </Text>
      {details.length > 0 && (
        <ul className="m-0 flex list-none flex-col gap-1.5 p-0">
          {details.map((detail, i) => (
            <li key={i} className="flex items-start gap-2 text-xs text-gray-600">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-gray-400" />
              <span>{detail}</span>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default TooltipContent;
